// #region Imports

import { ApiServiceBase } from './apiServiceBase';

// #endregion Imports

export class TourService extends ApiServiceBase {
    private apiUrl = '/api/usertour/1.0';

    getAllToursForCurrentUser(onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(`${this.apiUrl}/getalltoursforcurrentuser`, onSuccess, onFailure);
    }

    getTourForUser(tourId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.get(`${this.apiUrl}/gettourforuser/${tourId}`, onSuccess, onFailure,);
    }

    started(tourId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(`${this.apiUrl}/started/${tourId}`, onSuccess, onFailure,);
    }

    completed(tourId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(`${this.apiUrl}/completed/${tourId}`, onSuccess, onFailure,);
    }

    rejected(tourId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(`${this.apiUrl}/rejected/${tourId}`, onSuccess, onFailure,);
    }

    shutdown(tourId, onSuccess: (response: any) => void, onFailure: (response: any) => void) {
        this.post(`${this.apiUrl}/shutdown/${tourId}`, onSuccess, onFailure,);
    }
}